"use strict";
import f from "./index.es144.js";
import n from "./index.es148.js";
import l from "./index.es158.js";
function p(e, t) {
  const o = this || n, a = t || o, m = l.from(a.headers);
  let r = a.data;
  return f.forEach(e, function(i) {
    r = i.call(o, r, m.normalize(), t ? t.status : void 0);
  }), m.normalize(), r;
}
export {
  p as default
};
//# sourceMappingURL=index.es349.js.map
